import { useEffect, useState } from 'react';
import { useAuth } from '../../../context/AuthContext';
import { dashboardService } from '../../../services';
import './MyPublisherStats.css';

// Single-line summary of the currently logged-in publisher's own stats
// (Live/Total Created, Edits before Live/Total Live %), shown at the top
// of the Shorts page.
const MyPublisherStats = () => {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    if (!user?._id) return;
    let cancelled = false;

    dashboardService
      .getUserNewsStats({ userId: user._id, page: 1, limit: 1 })
      .then((response) => {
        if (cancelled) return;
        const row = Array.isArray(response.data) ? response.data[0] : null;
        setStats(row || null);
      })
      .catch((err) => {
        console.error('Failed to load my publisher stats:', err);
      });

    return () => {
      cancelled = true;
    };
  }, [user?._id]);

  if (!stats) return null;

  const editedLivePercent = stats.totalLive
    ? Math.round((stats.liveEditedCount / stats.totalLive) * 100)
    : null;

  const percentClass = editedLivePercent === null
    ? ''
    : editedLivePercent <= 30
      ? 'good'
      : editedLivePercent <= 60
        ? 'mid'
        : 'low';

  return (
    <div className="my-publisher-stats">
      <span className="my-publisher-stats-title">Your Stats</span>
      <span className="my-publisher-stats-item">
        Live/Total Created:{' '}
        <span className="my-publisher-stats-value my-publisher-stats-value-live">
          {stats.totalLive}/{stats.totalCreated}
        </span>
      </span>
      <span className="my-publisher-stats-item">
        Edits before Live/Total Live:{' '}
        <span className="my-publisher-stats-value my-publisher-stats-value-edits">
          {stats.liveEditedCount}/{stats.totalLive}
        </span>
        {editedLivePercent !== null && (
          <span className={`my-publisher-stats-percent ${percentClass}`}>{editedLivePercent}%</span>
        )}
      </span>
    </div>
  );
};

export default MyPublisherStats;
